import { useTranslation } from "react-i18next";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, FileText, User } from "lucide-react";
import type { HospitalPartner } from "@shared/schema";
import { StatusBadge } from "./shared";

export function PartnerCard({ partner, onView }: { partner: HospitalPartner; onView: () => void }) {
  const { t } = useTranslation();
  
  return (
    <Card className="hover-elevate cursor-pointer" onClick={onView} data-testid={`card-partner-${partner.id}`}>
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2">
            <Building2 className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">{partner.partnerName}</CardTitle>
          </div>
          <StatusBadge status={partner.status} />
        </div>
        <CardDescription className="flex items-center gap-1">
          <FileText className="h-3 w-3" />
          {partner.partnerCode}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-muted-foreground">{t('hospitalPartners.totalOrders', 'Total Orders')}</span>
            <p className="font-medium">{partner.totalOrders || 0}</p>
          </div>
          <div>
            <span className="text-muted-foreground">{t('hospitalPartners.totalDeliveries', 'Deliveries')}</span>
            <p className="font-medium">{partner.totalDeliveries || 0}</p>
          </div>
          <div>
            <span className="text-muted-foreground">{t('hospitalPartners.paymentPlans', 'Payment Schedules')}</span>
            <p className="font-medium">{partner.totalPaymentPlans || 0}</p>
          </div>
          <div>
            <span className="text-muted-foreground">{t('hospitalPartners.revenue', 'Revenue')}</span>
            <p className="font-medium">${((partner.totalRevenue || 0) / 100).toLocaleString()}</p>
          </div>
        </div>
        {partner.contactName && (
          <div className="mt-3 pt-3 border-t text-sm text-muted-foreground flex items-center gap-1">
            <User className="h-3 w-3" />
            {partner.contactName}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
